module.exports = __webpack_public_path__ + "img/title-1-btn.5cc60131.png";